import moment from 'moment';

window.global = window;
window.$ = window.jQuery;
window.moment = moment;

import '~/js/helpers/legacy/legacy';
import '~/js/helpers/legacy/form';

import '~/js/helpers/ajax';
import '~/js/helpers/frame';
import '~/js/helpers/data';
import '~/js/helpers/form';
import '~/js/helpers/potrace';
import '~/js/helpers/functions';
import '~/js/helpers/text';
import '~/js/helpers/tooltips';

import '~/js/imagical/cms/behav';
import '~/js/imagical/cms/init';
import '~/js/imagical/helpers/tabs';
import '~/js/imagical/form/progress';
import '~/js/imagical/form/input/inc';
import '~/js/imagical/form/form';

import '~/js/modules/calendar/fullcalendar';

function init() {
}

$(init());
